import './App.css';
import React from 'react';
import Admin from './pages/admin.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/auth/PrivateRoute.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-toastify/dist/ReactToastify.css';
import Sendotp from './components/onboarding/sendotp.js';
import Forgotpassword from './components/onboarding/verifyforgot.js'
import Login from './components/onboarding/login.js';


function App() {
  return (
    <div className='page'>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/sentotp" element={<Sendotp/>}/> 
          <Route path="/verifyotp" element={<Forgotpassword/>} />
          <Route path="/admin" element={ <PrivateRoute><Admin /></PrivateRoute> } />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
